import ApiV2 from './ApiV2';

export default class CursoService {
  static async getCursosAluno(id_entidade) {
    return ApiV2.get('/curso-aluno', {
      params: { id_entidade },
    });
  }
}
